export default __webpack_public_path__ + "static/3-dystopia-887500af173ef41bafde6b7784eb22a5.png";